import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import mq from '../../../styleUtility/mediaquery';

type Props = {
  titleMessageId: string;
  supportingTextMessageId: string;
  region: string;
  jpOnly?: boolean;
};

const SectionHeader: FC<Props> = ({ titleMessageId, supportingTextMessageId, region, jpOnly = false }) => {
  return (
    <>
      <Heading variant="h5">
        <FormattedMessage id={titleMessageId} />
      </Heading>
      <SupportingText variant="body2" color="textSecondary">
        {region === 'jp' ? (
          <FormattedMessage id={supportingTextMessageId} />
        ) : !jpOnly ? (
          <FormattedMessage id={`us_${supportingTextMessageId}`} />
        ) : null}
      </SupportingText>
    </>
  );
};

const Heading = styled(Typography)({
  marginBottom: SPACING_UNIT,
  [mq('sp')]: {
    fontSize: '1.3rem',
  },
});

const SupportingText = styled(Typography)({
  marginBottom: SPACING_REGULAR,
});
export default SectionHeader;
